
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {Quill} from 'quill'

import {Theme} from '../../shared/service/AutoTheme'
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ScriptService } from '../../setting/setting.service';
@Component({
  selector: 'app-script-editor',
  templateUrl: './script-editor.component.html',
  styleUrls: ['./script-editor.component.css']
})
export class ScriptEditorComponent implements OnInit {
  form: FormGroup;
  html: string;
  script:any=""
  name:any=""
  @Output() newItemEvent = new EventEmitter<any>();
  @Output() buttonClicked = new EventEmitter();
  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'size': ['xsmall', 'small', 'medium', 'large', 'xlarge']}],
        [{ 'align': [] }],
        ['clean'],                    
        ['link'],
      ],
    },
 }
  validate: boolean=false;
  submitted: boolean;
  
 constructor(public api:Theme,public router: Router,public route:ActivatedRoute ,public data:ScriptService,@Inject(MAT_DIALOG_DATA) public datas: any, private dialogRef: MatDialogRef<ScriptEditorComponent>){

 }
  ngOnInit(): void {
    
    console.log(this.route.snapshot.queryParams)
    if(this.route.snapshot.queryParams.data =='false' ){
    this.script=window.sessionStorage.getItem('scriptData')
    this.name=window.sessionStorage.getItem('nameData')
  }else{
    window.sessionStorage.removeItem('scriptData')
    window.sessionStorage.removeItem('nameData')
  }

  }
  onText(e,data){
    console.log(e)
    console.log(this.name);
    
    this.api.CallStatus({script:this.script,name:data})
  }
  handleClick() {
    this.submitted=true
    console.log("asfasdfasc")
    if(this.name=='' || this.script==''){
      alert("Blank Script is not allowed")
      this.validate=true
      return
    }
    
    // this.data.onSubmit(this.route.snapshot.queryParams,()=>{

    //   console.log("close");
    //   if(this.route.snapshot.queryParams.data!='false'){
    //     if((this.route.snapshot['_routerState'].url).split('?')[0]=='/main/setting/addscript'){
    //       console.log("if")
    //       this.router.navigate(['/main/setting/script'])
    //       }else{
    //         console.log("else",this.route.snapshot['_routerState'])
    //         // this.router.navigate([(this.route.snapshot['_routerState'].url).split('?')[0]])
    //         this.router.navigate([(this.route.snapshot['_routerState'].url)])

    //       }
    //   }
    //   this.dialogRef.close()
      
    // })
    
    

  }
  close(){
    this.dialogRef.close("close")
  }

}
